import actionCreator from '../../createAction';

const createAction = actionCreator('contacts');

export const GET_CONTACTS = createAction('GET_CONTACTS');
export const GET_CONTACT = createAction('GET_CONTACT');
export const RESET_CONTACTS = createAction('RESET_CONTACTS');
export const CREATE_CONTACT = createAction('CREATE_CONTACT');
export const UPDATE_CONTACT = createAction('UPDATE_CONTACT');
export const DELETE_CONTACT = createAction('DELETE_CONTACT');
export const RESTORE_CONTACT = createAction('RESTORE_CONTACT');
export const BLOCK_CONTACT = createAction('BLOCK_CONTACT');
export const UNBLOCK_CONTACT = createAction('UNBLOCK_CONTACT');
export const GET_CONTACT_GROUPS = createAction('GET_CONTACT_GROUPS');
export const ADD_TO_GROUP = createAction('ADD_TO_GROUP');
export const REMOVE_FROM_GROUP = createAction('REMOVE_FROM_GROUP');
export const GET_CONTACT_GROUPS_COUNT = createAction(
  'GET_CONTACT_GROUPS_COUNT',
);

export const BULK_ADD_TO_GROUP = createAction('BULK_ADD_TO_GROUP');
export const BULK_REMOVE_FROM_GROUP = createAction('BULK_REMOVE_FROM_GROUP');
export const BULK_DELETE = createAction('BULK_DELETE');
export const BULK_RESTORE_CONTACTS = createAction('BULK_RESTORE_CONTACTS');
export const MERGE_CONTACT = createAction('MERGE_CONTACT');

export const GET_COMMENTS = createAction('GET_COMMENTS');
export const ADD_COMMENT = createAction('ADD_COMMENT');
export const EDIT_COMMENT = createAction('EDIT_COMMENT');
export const DELETE_COMMENT = createAction('DELETE_COMMENT');

export const LOAD_CUSTOM_TABS = createAction('LOAD_CUSTOM_TABS');
export const DELETE_CUSTOM_TAB = createAction('DELETE_CUSTOM_TAB');
export const CREATE_CUSTOM_TAB = createAction('CREATE_CUSTOM_TAB');
export const UPDATE_CUSTOM_TAB = createAction('UPDATE_CUSTOM_TAB');
